export class IntegerFilter {
    public greaterThan?: number;
    public lessThan?: number;
    public equal?: number[];
}
